import { api } from './base';

export interface LabelInfo {
  id: number;
  name: string;
}

export interface ListLabelInfosResult {
  labels: Array<LabelInfo>;
}

export interface SiteInfo {
  id: number;
  description: string;
  address: string;
  name: string;
  title: string;
}

export interface ListLabelSiteResult {
  sites: Array<SiteInfo>;
}

export interface SaveLabelResult {
  label: LabelInfo;
}

export const labelAdminApis = {
  async listLabels() {
    const result = await api.get<ListLabelInfosResult>(`/labels`);
    return result.labels;
  },

  async listLabelSites(label_id: number) {
    const result = await api.get<ListLabelSiteResult>(`/label/sites/${label_id}`);
    return result.sites;
  },

  async saveLabel(label: LabelInfo | null) {
    const result = await api.post<SaveLabelResult>(`/admin/label`, label);
    return result.label;
  },

  delLabel(label_id: number) {
    return api.delete(`/admin/label/${label_id}`);
  }
};
